import { getProducts } from "/src/main.js";
import { writable } from "svelte/store";

export const getCart = () => {
    try {
        const cart = localStorage.getItem("cart");
        return JSON.parse(cart) || [];
    } catch (error) {
        return [];
    }
};

export const getCartProducts = async () => {
    const cart = getCart();
    const products = await getProducts();

    return cart
        .map(cartItem => {
            const product = products.find(product => product._id === cartItem.product_id);
            if (product) {
                return {
                    ...product,
                    selected_size: cartItem.size,
                    id_in_cart: cartItem._id,
                };
            }
        })
        .filter(Boolean);
};

const cartStore = writable([]);

const initializeCartStore = async () => {
    const initialCartProducts = await getCartProducts();
    cartStore.set(initialCartProducts);
};

// Инициализация данных в хранилище
initializeCartStore();

export const addToCart = async (product) => {
    try {
        const cartArray = getCart();
        cartArray.push(product);

        localStorage.setItem("cart", JSON.stringify(cartArray));
        cartStore.set(await getCartProducts());
    } catch (error) {
        localStorage.setItem("cart", JSON.stringify([]));
        cartStore.set([]);
    }
};

export const removeFromCart = async (id) => {
    try {
        let cart = getCart();
        cart = cart.filter(item => item._id !== id);

        localStorage.setItem("cart", JSON.stringify(cart));
        cartStore.set(await getCartProducts());
    } catch (error) {
        localStorage.setItem("cart", JSON.stringify([]));
        cartStore.set([]);
    }
};

export default cartStore;
